import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDss2X9bFC6dK0R5PlBn3Az3PS5xzkXA6c",
  authDomain: "vet-alzan.firebaseapp.com",
  projectId: "vet-alzan",
  storageBucket: "vet-alzan.appspot.com",
  messagingSenderId: "1088493583200",
  appId: "1:1088493583200:web:b29819c410e81437807c05",
  measurementId: "G-F4M1RN8TGX"
};

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const analytics = getAnalytics(app);

// Função para obter o messaging de forma assíncrona
export const getMessagingInstance = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      return getMessaging(app);
    }
    return null;
  } catch (error) {
    console.error('Firebase Messaging não é suportado:', error);
    return null;
  }
};
